export const pageUtilitiesMixin = {
    methods: {
        isScrolledToBottom: function (el) {
            // NOTE: scrollTop is fractional, while scrollHeight and clientHeight are
            // not, so without this Math.abs() trick then sometimes the result won't
            // work because scrollTop may not be exactly equal to el.scrollHeight -
            // el.clientHeight when scrolled to the bottom.
            return Math.abs(el.scrollHeight - el.clientHeight - el.scrollTop) < 1
        }
    }
};